import { PortfolioItemModel } from "../../features/portfolio-info/types/PortfolioItemModel";
import { AssetType } from "../types/AssetType";
import { PortfolioGroupedItemModel } from "../../features/portfolio-summary/types/PortfolioGroupedItemModel";
import { PositionModel } from "../../features/portfolio-info/types/PositionModel";
import { PortfolioGroupedItem } from "../../screens/positions-and-orders/models/PortfolioGroupedItem";

class AssetService {
    isOption = (item: PortfolioItemModel): boolean =>
        item.type === AssetType.Call || item.type === AssetType.Put;
    
    isOptionType = (type: AssetType): boolean =>
        type === AssetType.Call || type === AssetType.Put;
    
    isOptionExpired = (item: PortfolioItemModel): boolean =>
        item.expirationPrice !== null;

    isGroupedOptions = (item: PortfolioGroupedItemModel): boolean =>
        item.type === AssetType.Call || item.type === AssetType.Put;

    isGroupedOptionsExpired = (item: PortfolioGroupedItemModel): boolean =>
        item.expirationPrice !== null;

    isOptionPositionExpired = (item: PortfolioGroupedItem): boolean =>
        item.expirationPrice !== null;
    
    isPositionOption = (item: PositionModel): boolean =>
        item.type === AssetType.Call || item.type === AssetType.Put;

    isPositionOptionExpired = (position: PositionModel): boolean =>
        position.expirationPrice !== null;
}

export const assetService = new AssetService();